module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyList":"No item to display (empty list)"},"fr":{"emptyList":"Aucun élément à afficher (liste vide)"}}')
  delete Component.options._Ctor
}
